import { Button, type ButtonProps } from "react-bootstrap";
import { MdCancel } from "react-icons/md";

const CancelButton: TTButtonProps = ({ children, ...props }) => (
  <Button variant="secondary" {...(props as ButtonProps)}>
    <MdCancel /> {children}
  </Button>
);

export default CancelButton;
